
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire164e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire164e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("c248P", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $8c28e2592fa269ae$export$6503ec6e8aabbaf; }, function (v) { return $8c28e2592fa269ae$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $8c28e2592fa269ae$export$f7ad0328861e2f03; }, function (v) { return $8c28e2592fa269ae$export$f7ad0328861e2f03 = v; });
var $8c28e2592fa269ae$export$6503ec6e8aabbaf;
var $8c28e2592fa269ae$export$f7ad0328861e2f03;
"use strict";
var $8c28e2592fa269ae$var$mapping = new Map();
function $8c28e2592fa269ae$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$8c28e2592fa269ae$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $8c28e2592fa269ae$var$resolve(id) {
    var resolved = $8c28e2592fa269ae$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$8c28e2592fa269ae$export$6503ec6e8aabbaf = $8c28e2592fa269ae$var$register;
$8c28e2592fa269ae$export$f7ad0328861e2f03 = $8c28e2592fa269ae$var$resolve;

});

var $ef59e0fcc863d5dc$exports = {};

(parcelRequire("c248P")).register(new URL("", import.meta.url).toString(), JSON.parse('["bBZS7","index.d8618d1e.js","jd6wv","About.6e26cab3.js"]'));


//# sourceMappingURL=index.runtime.6e6918ca.js.map
